import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { Flex, Separator, Text, VStack } from "@chakra-ui/react";

import { TrialAwareLayoutSpinner } from "@components/layout";
import OAuthConnector from "@components/oauth-connector";

// import { useConnectionStatusQuery } from "@state/apiSlice/requests";
import { selectMondayAccountId } from "@state/mondaySlice";

function ConnectionsPageContents() {
  // const mondayAccountId = useSelector(selectMondayAccountId);
  // const location = useLocation();
  // const navigate = useNavigate();

  // const {
  //   data: connectionStatusData,
  //   isLoading,
  //   refetch,
  // } = useConnectionStatusQuery({}, { skip: !mondayAccountId });

  // const queryParams = new URLSearchParams(location.search);
  // const isReconnectMode = queryParams.get("reconnect") === "true";

  // const updateHideSideBar = () => {
  //   if (!location.pathname.includes("settings")) {
  //     navigate("/", {
  //       replace: true,
  //     });
  //   }
  // };

  // const oAuthCallback = () => {
  //   refetch();
  //   updateHideSideBar();
  // };

  // if (isLoading) {
  //   return <TrialAwareLayoutSpinner />;
  // }

  // const contents = () => (
  //   <Flex
  //     align="start"
  //     direction="column"
  //     flex={isReconnectMode ? undefined : "1"}
  //     maxW="2xl"
  //   >
  //     <Text
  //       fontSize="lg"
  //       fontWeight="medium"
  //     >
  //       Connections
  //     </Text>
  //     <Text
  //       fontSize="sm"
  //       color="gray.600"
  //     >
  //       Manage connections to third parties.
  //     </Text>

  //     <Separator
  //       my="24px"
  //       w="full"
  //     />

  //     <VStack
  //       align="flex-start"
  //       gapY="24px"
  //     >
  //       <OAuthConnector
  //         type="monday"
  //         data={connectionStatusData}
  //         isLoading={isLoading}
  //         oAuthCallback={oAuthCallback}
  //       />

  //       <OAuthConnector
  //         type="xero"
  //         data={connectionStatusData}
  //         isLoading={isLoading}
  //         oAuthCallback={oAuthCallback}
  //       />
  //     </VStack>
  //   </Flex>
  // );

  // if (isReconnectMode) {
  //   return (
  //     <Flex
  //       flex="1"
  //       justify="center"
  //       align="center"
  //       p={4}
  //     >
  //       {contents()}
  //     </Flex>
  //   );
  // }

  // return contents();

  return <h1>Ye</h1>
}

export default ConnectionsPageContents;
